<template>
	<div class="page-profile">

		<section class="section-left">
			<div class="section-left-content">
				<el-row>
					<el-col :span="24">
						<MenuHeader />
					</el-col>
				</el-row>
			</div>
		</section>
		
		<section class="section-center">
			<main>
				<el-container>
					<el-row>
						<el-col :span="24" v-if="user && user.data">

							<section class="card">
								<p>Información personal</p>
								
								<el-row>
									<el-col :span="6" class="text-right">Foto principal</el-col>
									<el-col :span="10" :offset="2">
										<div class="change-avatar">
											<img src="/ficha/img/fushima_logo_60.5b493b05.png" />
											<div class="action">
												<el-button type="primary">Cambiar foto</el-button>
												<span>Aceptamos formatos .jpg y mínimo 400 x 400px</span>
											</div>
										</div>
									</el-col>
								</el-row>

							</section>

							<section class="card">
								<p>Información cuenta</p>

								<el-row>
									<el-col :span="6" class="text-right">Email</el-col>
									<el-col :span="10" :offset="2">
										<el-input></el-input>
									</el-col>
								</el-row>

								<el-row>
									<el-col :span="6" class="text-right">Contraseña</el-col>
									<el-col :span="10" :offset="2">
										<el-input></el-input>
									</el-col>
								</el-row>
							</section>
							
						</el-col>
					</el-row>
				</el-container>
			</main>
		</section>

	</div>
</template>

<script>
	import MenuHeader from '@/components/Porlet/PorletMenuHeader.vue'
	import InfoBox from '@/components/Porlet/PorletInfoBox.vue'

	import { mapState } from 'vuex'

	export default {
		name: 'Profile',
		components: {
			MenuHeader,
			InfoBox
		},
		data() {
			return {
				
			}
		},
		mounted() {
			console.log('profile')
		},
		computed: {
			...mapState({
				user: state => state.user
			})
		},
		methods: {
			
		}
	}
</script>

<style lang="scss">
.page-profile {
	display: flex;

	// LEFT SECTION
	.section-left {
		width: 200px;
		height: 100vh;
		display: flex;
		flex-shrink: 0;
		background-color: white;
    	border-right: 1px solid rgba(0,0,0,.1);
		.section-left-content {
			width: 90%;
		}
	}

	// CENTER SECTION
	.section-center {
		height: 100vh;
		
		overflow: auto;
		//padding: 20px;
		flex-grow: 0;
		flex-shrink: 0;

		display: flex;
		flex-flow: row;
		flex-grow: 1;
		flex-shrink: 1;

		background-color:#edeff3;
		overflow-x: hidden;
		.text-right {
			text-align: right;
		}

		main {
			width: 100%;
			max-width: 900px;
    		padding: 15px 20px;

			.el-row {
				width: 100%;
			}

			section.card {
				background-color: white;
				border-radius: 6px;
				border: 1px solid #e5e5e5;
				padding: 40px;
				margin-bottom: 20px!important;

				> p {
					font-size: 1rem;
					color: #646464;
					font-weight: 600;
					margin: 0px 0px 35px 0px;
				}
				> .el-row {
					margin-bottom: 20px;
					.change-avatar {
						display: flex;
						align-items: center;
						
					}
				}
			}
		} 
	}
}
</style>
